import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchInvestigationMaster } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getInvestigationlist } from "../../../redux/action/investigation_action";

const InvestigationDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
}) => {
  const login = useSelector((state) => state.jwtAuthreducer);
  const dispatch = useDispatch();
  const selectedInvestigationId = watch("investigation_id");
  const labDepartmentId =
    getValues()?.lab_department_id ||
    rowData?.lab_department_obj?.id ||
    rowData?.lab_department_id ||
    0;

  const investigationName =
    rowData?.investigation_obj?.investigation_name ||
    rowData?.investigation_name ||
    getValues().investigation_name;

  const investigationId =
    rowData?.investigation_obj?.id ||
    rowData?.investigation_id ||
    getValues().investigation_id;

  const payload = labDepartmentId
    ? { lab_department_id: labDepartmentId, ...login }
    : { ...login };

  const {
    data: Investigations,
    refetch,
    isLoading,
    error,
  } = useQuery(
    ["Investigation", labDepartmentId],
    () => fetchInvestigationMaster(payload),
    {
      enabled: labDepartmentId !== null,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  useEffect(() => {
    refetch();
  }, [login]);

  const options = useMemo(() => {
    return (
      Investigations?.data?.data?.map((ele) => ({
        value: ele.id,
        label: ele.investigation_name,
      })) || []
    );
  }, [Investigations]);

  const selectedOption = useMemo(() => {
    return (
      options.find((option) => option.value === selectedInvestigationId) ||
      options.find((option) => option.value === investigationId) ||
      options.find((option) => option.label === investigationName) ||
      null
    );
  }, [options, selectedInvestigationId, investigationId, investigationName]);

  useEffect(() => {
    if (rowData && options.length) {
      const rowDataOption = options.find(
        (option) =>
          option.value === rowData?.investigation_obj?.id ||
          option.value === rowData?.investigation_id
      );
      if (rowDataOption) {
        setValue("investigation_id", rowDataOption.value);
        setValue("investigation_name", rowDataOption.label);
      }
    }
  }, [rowData, options, setValue, labDepartmentId]);

  useEffect(() => {
    if (selectedOption) {
      setValue("investigation_id", selectedOption.value);
      setValue("investigation_name", selectedOption.label);
    } else {
      setValue("investigation_id", null);
      setValue("investigation_name", "");
    }
  }, [selectedOption, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Investigation Data</div>;

  return (
    <Controller
      name="investigation_id"
      control={control}
      rules={{
        required: required ? "Investigation Name is required" : false,
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Investigation Name"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("investigation_id", value);
            setValue(
              "investigation_name",
              selectedOption ? selectedOption.label : ""
            );
            dispatch(getInvestigationlist(value));
          }}
          className={`react-select-container ${
            errors.investigation_id ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default InvestigationDropdown;
